import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { get } from '../constants';

import ButtonBase from './ButtonBase';

const ButtonText = styled(ButtonBase)`
  ${({ color }) => css`
    background-color: transparent;
    color: ${get(`colors.${color}`)};
    border: 2px solid transparent;

    &:hover {
      background-color: transparent;
      color: ${get(`colors.${color}Dark`)};
      text-decoration: underline;
    }

    &:focus {
      background-color: transparent;
      color: ${get(`colors.${color}Dark`)};
      text-decoration: underline;
    }

    &:active {
      /* Use ${get(`colors.${color}Lighter`)} when color theme is not generate from code */
      background-color: transparent;
      border-color: transparent;

      color: ${get(`colors.${color}Dark`)};
      text-decoration: underline;
    }

    &:disabled {
      background-color: transparent;
      color: ${get(`colors.${color}Light`)};
      border-color: transparent;
      text-decoration: none;
      cursor: not-allowed;
    }
  `}
`;

ButtonText.propTypes = {
  color: PropTypes.string,
  ...ButtonBase.propTypes,
};

ButtonText.defaultProps = {
  color: 'primary',
};

export default ButtonText;
